export default __webpack_public_path__ + "static/phf-7e48e52131a1294ce96d5ca0553e982a.jpg";